var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"nav"},[_c(_vm.menuByRole,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }